import { Campaign } from './campaign';

export class CampaignResponse {
  offset: number;
  limit: number;
  totalPages: number;
  totalElements: number;
  campaigns: Array<Campaign> = [];
}
